import { render } from "./TotalAccountsReceivableForTheCurrentMonth.vue?vue&type=template&id=0ce462cc"
import script from "./TotalAccountsReceivableForTheCurrentMonth.vue?vue&type=script&lang=js"
export * from "./TotalAccountsReceivableForTheCurrentMonth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__